import React from "react"

// components
import { Typography, Avatar, Tooltip, Image } from "antd"

// i18n
import { useTranslation } from "react-i18next"

// config
import config from "config"

const MenuItemTooltipContent = ({ item }) => {
  const { i18n } = useTranslation()
  const lang = i18n.resolvedLanguage

  const name = item.name_i18n?.[lang] ?? item.name
  const info = item.info_i18n?.[lang] ?? item.info

  return (
    <div>
      <Typography.Text
        strong
        style={{
          color: "white",
          fontSize: 36,
          lineHeight: 1,
          marginBottom: 8,
          display: "block",
        }}
      >
        {name}
      </Typography.Text>

      {item.hasImage && (
        <Image
          src={`restos/${config.key}/menu/${String(item.id).toLowerCase()}.png`}
          alt={`img-${item.id}`}
          preview={false}
          width={200}
        />
      )}

      <Typography.Paragraph
        strong
        style={{
          color: "white",
          fontSize: 14,
        }}
      >
        {info}
      </Typography.Paragraph>

      {item?.details && (
        <Typography.Paragraph
          style={{
            color: "white",
          }}
          italic
          type="secondary"
        >
          {item.details}
        </Typography.Paragraph>
      )}

      <Typography.Paragraph
        style={{
          color: "white",
          fontSize: 14,
        }}
      >
        {item.scharf > 0 &&
          (item.scharf === 2 ? (
            <span>
              <Avatar
                src="icons/chili.png"
                size={16}
                alt="icon-chili"
                style={{ marginRight: "-10px" }}
              />
              <Avatar src="icons/chili.png" size={16} alt="icon-chili" />
              scharf
            </span>
          ) : (
            <span>
              <Avatar src="icons/chili.png" size={16} alt="icon-chili" />
              scharf
            </span>
          ))}{" "}
        {item.vegetarisch > 0 && (
          <span>
            {item.scharf > 0 && ", "}
            <Avatar src="icons/leaf.png" size={16} alt="icon-leaf" />{" "}
            vegetarisch
          </span>
        )}
      </Typography.Paragraph>

      {item.zusatz && item.zusatz.length > 0 && (
        <Tooltip
          zIndex={2}
          color="white"
          trigger="click"
          title={
            <div>
              {item.zusatz.map((z) => (
                <Typography.Paragraph
                  key={z}
                  size="small"
                  style={{ margin: 0 }}
                >
                  -{" "}
                  {config.add_ons[z] ||
                    config.add_ons[(z + "").toUpperCase()] ||
                    z}
                </Typography.Paragraph>
              ))}
            </div>
          }
        >
          <Typography.Text
            italic
            style={{
              color: "white",
              fontSize: 10,
            }}
          >
            Zusatz: {item.zusatz.join(", ")}
          </Typography.Text>
        </Tooltip>
      )}
    </div>
  )
}

export default MenuItemTooltipContent
